import { type Country } from "@leabankab/component-library";

export type NationalIdCountry = Extract<Country, "SE" | "FI">;

const RULES: Record<
	NationalIdCountry,
	{ normalize: (value: string) => string; length: number }
> = {
	SE: { normalize: (value) => value.replace(/\D/g, ""), length: 12 },
	// HETU keeps its century marker (`+`, `-`, `A`) and check character.
	FI: {
		normalize: (value) =>
			value.replace(/[^0-9A-Za-z+-]/g, "").toUpperCase(),
		length: 11,
	},
};

/** Strips typed formatting while keeping characters the checksum needs. */
export const normalizeNationalId = (
	country: NationalIdCountry,
	value: string
): string => RULES[country].normalize(value);

export const getNationalIdLength = (country: NationalIdCountry): number =>
	RULES[country].length;
